import { constants } from '@yola/subscription-manager-js';

const {
  SubscriptionTerm: { MONTHLY },
} = constants;

const isSpecialOfferAvailable = ({ extraPriceType, activeHostingSubscription }) => {
  if (!extraPriceType) {
    return false;
  }

  if (activeHostingSubscription?.term === MONTHLY) {
    return false;
  }

  return true;
};

export default isSpecialOfferAvailable;
